import { Component, OnInit } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { CafeMenuService } from 'src/app/Services/cafe-menu.service';
import { TodayMenuService } from 'src/app/Services/todaymenu.service';
import { CafeMenuNamesService } from 'src/app/Services/cafe-menu-names.service';
import { CafeMenuTimesService } from 'src/app/Services/cafe-menu-times.service';
import { Time } from '@angular/common';
import * as moment from 'moment';
import { MenuItem } from 'src/app/Models/days-menu';
import { CafeMenuName } from 'src/app/Models/cafe-menu-name';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';

type cafemenuInfo = {
  mituid: number;
  mitName: string;
  mitGuestDescription: string;
  mitmttuid: number;
  mttName: string;
};

type cafemenutimeInfo = {
  aiiActivityName: string;
  cruCode: string;
  catName: string;
  slnname: string;
  aiiDate: Date;
  aiibegtime: Time;
  aiiendtime: Time;
  asofdate: string;
};

@Component({
  selector: 'app-cafe-menu',
  templateUrl: './cafe-menu.component.html',
  styleUrls: ['./cafe-menu.component.css'],
  providers: [
    CafeMenuNamesService,
    CafeMenuService,
    CafeMenuTimesService,
    TodayMenuService,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CafeMenuComponent implements OnInit {
  OBPortalSvcURL = '';

  userdata?: UserData;
  shpid: number | undefined;

  MenuItems: MenuItem[] = [];
  MenuItemsTemp: MenuItem[] = [];
  Menudata: any;
  begdate: Date | string | undefined;
  enddate: Date | string | undefined;

  // American Eagle Lookout Cafe
  // slnshpid: number | undefined;
  // slnshpid = 4;
  // ltyname: string = '';
  ltyname = 'Cafe';

  mttName = 'Cafe%';

  // cruCode = 'HAR240816';
  cruCode: string | undefined;

  // aiiDate: any | undefined;
  // aiiDate = 2024-8-20;

  asofdate: string | undefined;
  // asofdate = '2024-08-20T00:00:00';

  cafemenunamedata: any;
  cafemenunames: CafeMenuName[] = [];

  cafemenudata: any;
  cafemenus: cafemenuInfo[] = [];

  cafemenutimedata: any;
  cafemenutimes: cafemenutimeInfo[] = [];

  constructor(
    private appConfigService: AppConfigService,
    private CafeMenuNamesService: CafeMenuNamesService,
    private CafeMenuService: CafeMenuService,
    private CafeMenuTimesService: CafeMenuTimesService,
    private todayMenuService: TodayMenuService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.shpid = this.userdata?.shipid!;
    this.begdate = this.userdata?.pckgBeg;
    this.enddate = this.userdata?.pckgEnd;
    this.cruCode = cruiseContentEvtCodeFromSession(this.userdata);
    this.asofdate = moment().format('YYYY-MM-DD');
    this.getCafeMenuNames();
  }

  getCafeMenuNames() {
    this.cafemenunamedata = this.CafeMenuNamesService.getCafeMenuNames(
      this.shpid,
      this.ltyname
    ).subscribe((cafemenunamedata) => this.setCafeMenuNames(cafemenunamedata));
  }
  setCafeMenuNames(resdata: any) {
    this.cafemenunamedata = resdata;
    if (this.cafemenunamedata.GetCafeMenuNames.Result.Status == 'A') {
      this.cafemenunames =
        this.cafemenunamedata.GetCafeMenuNames.CafeMenuNamesList;
      this.getCafeMenus();
    }
  }

  getCafeMenus() {
    this.cafemenudata = this.CafeMenuService.getCafeMenus(
      this.mttName
    ).subscribe((cafemenudata) => this.setCafeMenus(cafemenudata));
  }
  setCafeMenus(resdata: any) {
    this.cafemenudata = resdata;
    if (this.cafemenudata.GetCafeMenus.Result.Status == 'A') {
      this.cafemenus = this.cafemenudata.GetCafeMenus.CafeMenusList.filter(
        (s: { mttName: string }) =>
          s.mttName.includes('Cafe Breakfast') ||
          s.mttName.includes('Cafe Small Plates') ||
          s.mttName.includes('Cafe Lunch') ||
          s.mttName.includes('Cafe Dessert')
      );

      //remove the extra word cafe from showing on the page that is in SQL database from the words cafe breakfast, cafe small plates, cafe lunch, cafe dessert
      this.cafemenus.forEach((currentValue, index) => {
        if (currentValue.mttName.includes('Cafe Breakfast'))
          currentValue.mttName = 'Breakfast';
        if (currentValue.mttName.includes('Cafe Small Plates'))
          currentValue.mttName = 'Small Plates';
        if (currentValue.mttName.includes('Cafe Lunch'))
          currentValue.mttName = 'Lunch';
        if (currentValue.mttName.includes('Cafe Dessert'))
          currentValue.mttName = 'Dessert';
      });
      this.getCafeMenuTimes();
    }
  }

  getCafeMenuTimes() {
    this.cafemenutimedata = this.CafeMenuTimesService.getCafeMenuTimes(
      this.cruCode,
      this.asofdate
    ).subscribe((cafemenutimedata) => this.setCafeMenuTimes(cafemenutimedata));
  }
  setCafeMenuTimes(resdata: any) {
    this.cafemenutimedata = resdata;
    if (this.cafemenutimedata.GetCafeMenuTimes.Result.Status == 'A') {
      this.cafemenutimes =
        this.cafemenutimedata.GetCafeMenuTimes.CafeMenuTimesList;
    }
  }
}
